/* eslint-disable */

const init = () => {
	const barChartsArr = document.querySelectorAll('.js-bar-chart');
	if (barChartsArr.length > 0) {
		barChartsArr.forEach(barChart => {
			const chartBarColumnArr = barChart.querySelectorAll('.chartbar');
			if (chartBarColumnArr.length > 0) {
				chartBarColumnArr.forEach(bar => {
					const barHeightAttr = bar.getAttribute('data-chartbar-bar') || 0;
					bar.style.height = `${parseFloat(barHeightAttr, 10) * 100}%`;

					const barFractionsArr = bar.querySelectorAll('.chartbar__fraction');
					barFractionsArr.forEach(fraction => {
						const fractionValue = parseFloat(fraction.getAttribute('data-chartbar-fraction'), 10) * 100;
						fraction.style.flex = `1 1 ${fractionValue}%`;
					});
				});
			}
		})
	}
};

export default {
	init,
};
/* eslint-enable */
